import {createReducer, on} from '@ngrx/store';
import {PaginationFiltersState, PaginationFilterState} from '../../core/models/entities';
import {clearPaginationFilter, setPaginationFilter} from './paginationFilter.actions';
import {initialStatePaginationFilter} from './paginationSelector.state';

export const paginationFilterReducer = createReducer(
    initialStatePaginationFilter,
    on(setPaginationFilter, (state: PaginationFiltersState, action: { context: string; paginationFilter: PaginationFilterState }) => ({
        ...state,
        [action.context]: {
            filter: action.paginationFilter?.filter ?? state[action.context]?.filter ?? { code: undefined, description: undefined },
            pagination: action.paginationFilter?.pagination ?? state[action.context]?.pagination ?? { pageNumber: 0, pageSize: 0, totalElements: 0, first: false, last: false },
            sort: action.paginationFilter.sort ?? state[action.context]?.sort ?? [],
        },
    })),
    on(clearPaginationFilter, (state: PaginationFiltersState, action: { context: string | null }) => {
        if (!action.context) {
            return {};
        } else {
            const { [action.context]: removed, ...newState } = state;
            return newState;
        }
    })
);

